module.exports = __webpack_public_path__ + "img/0ae5d43b2ec2a97c892a27825771d184.891213c4.png";